export { default } from './GridBlogPosts.vue'
